(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["falcon-google-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
const controllers = new Map();
const initialize = (root = document) => {
root.querySelectorAll('[data-falcon-reviews]').forEach((section) => {
const sectionId = section.dataset.sectionId;
const existing = controllers.get(sectionId);
if (existing?.element === section) return;
existing?.destroy();
const viewport = section.querySelector('[data-reviews-viewport]');
const button = section.querySelector('[data-reviews-motion-button]');
const originalGroup = section.querySelector('.falcon-google-reviews__group');
if (!viewport || !button || !originalGroup) return;
const pauseIcon = button.querySelector('[data-reviews-pause-icon]');
const resumeIcon = button.querySelector('[data-reviews-resume-icon]');
const editorRoot = section.closest('.shopify-section') || section;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const mobileViewport = window.matchMedia('(max-width: 749px)');
let userPaused = false;
let focusInside = section.contains(document.activeElement);
let editorSelected = false;
const update = () => {
const supportsMotion = !reducedMotion.matches && !mobileViewport.matches;
const hasOverflow = originalGroup.scrollWidth > viewport.clientWidth + 1;
const canAnimate = supportsMotion && hasOverflow && !focusInside && !editorSelected;
if (canAnimate && section.dataset.motion !== 'enabled') viewport.scrollLeft = 0;
section.dataset.motion = canAnimate ? 'enabled' : 'static';
section.dataset.paused = String(userPaused || focusInside || editorSelected || document.hidden);
viewport.tabIndex = canAnimate ? -1 : 0;
button.hidden = !supportsMotion || !hasOverflow;
button.parentElement.hidden = button.hidden;
button.setAttribute('aria-pressed', String(userPaused));
button.setAttribute('aria-label', userPaused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
pauseIcon.hidden = userPaused;
resumeIcon.hidden = !userPaused;
};
const toggle = () => { userPaused = !userPaused; update(); };
const focus = (event) => { focusInside = true; update(); event.target.closest('[data-review-block-id]')?.scrollIntoView({ block: 'nearest', inline: 'nearest' }); };
const blur = (event) => { focusInside = section.contains(event.relatedTarget); update(); };
const select = () => { editorSelected = true; update(); };
const deselect = () => { editorSelected = false; update(); };
button.addEventListener('click', toggle);
section.addEventListener('focusin', focus);
section.addEventListener('focusout', blur);
editorRoot.addEventListener('shopify:section:select', select);
editorRoot.addEventListener('shopify:block:select', select);
editorRoot.addEventListener('shopify:section:deselect', deselect);
editorRoot.addEventListener('shopify:block:deselect', deselect);
reducedMotion.addEventListener('change', update);
mobileViewport.addEventListener('change', update);
document.addEventListener('visibilitychange', update);
const resizeObserver = new ResizeObserver(update);
resizeObserver.observe(viewport);
resizeObserver.observe(originalGroup);
update();
controllers.set(sectionId, { element: section, destroy() {
button.removeEventListener('click', toggle);
section.removeEventListener('focusin', focus);
section.removeEventListener('focusout', blur);
editorRoot.removeEventListener('shopify:section:select', select);
editorRoot.removeEventListener('shopify:block:select', select);
editorRoot.removeEventListener('shopify:section:deselect', deselect);
editorRoot.removeEventListener('shopify:block:deselect', deselect);
reducedMotion.removeEventListener('change', update);
mobileViewport.removeEventListener('change', update);
document.removeEventListener('visibilitychange', update);
resizeObserver.disconnect();
controllers.delete(sectionId);
}});
});
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true }); else initialize();
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('shopify:section:unload', event => controllers.get(event.detail?.sectionId)?.destroy());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
